"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchRequestAcknowledgementType = void 0;
var LaunchRequestAcknowledgementType;
(function (LaunchRequestAcknowledgementType) {
    LaunchRequestAcknowledgementType["StreamingAgentReady"] = "streamingAgentReady";
    LaunchRequestAcknowledgementType["StreamingAgentFinished"] = "streamingAgentFinished"; // the streaming agent has indicated to the Platform that it has successfully completed its job
})(LaunchRequestAcknowledgementType = exports.LaunchRequestAcknowledgementType || (exports.LaunchRequestAcknowledgementType = {}));
//# sourceMappingURL=LaunchRequestAcknowledgementType.js.map